import { InputLabel, Stack, TextField } from '@hiiretail/react-foundation-ui';
import { ReceiptFormData } from 'common/receipt.types';
import { isPositiveNumber } from 'common/utils/isPositiveNumber';
import { Controller, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

const styles = {
  stack: {
    gap: 1,
    width: 300,
  },
  label: {
    fontSize: 24,
    color: '#222',
    flexShrink: 0,
  },
};

export const GrossTotalInput = () => {
  const intl = useIntl();

  const {
    control,
    formState: { errors },
  } = useFormContext<ReceiptFormData>();

  return (
    <Stack sx={styles.stack}>
      <InputLabel sx={styles.label}>
        {intl.formatMessage({ id: 'receipt.VATSummary.grossTotal' })}
      </InputLabel>
      <Controller
        name="grossTotal"
        control={control}
        rules={{
          required: intl.formatMessage({ id: 'receipt.input.required' }),
          validate: { isPositiveNumber },
        }}
        render={({ field }) => (
          <TextField
            placeholder={intl.formatMessage({ id: 'receipt.input.placeholder' })}
            type="number"
            size="small"
            {...field}
            error={!!errors.grossTotal}
            helperText={errors.grossTotal?.message}
          />
        )}
      />
    </Stack>
  );
};
